import { Card, Checkbox, Form, Input, Select, Space } from "antd";
import type { ProposeTemplateField, ProposeTemplateFormDefinition } from "../api/proposeTemplatesApi";

const fieldOptions = (options: unknown[] = []) =>
  options.map((option) => {
    if (typeof option === "string" || typeof option === "number") {
      return { value: option, label: String(option) };
    }
    if (option && typeof option === "object") {
      const record = option as Record<string, unknown>;
      const value = record.value ?? record.id ?? record.label ?? "";
      return {
        value: String(value),
        label: String(record.label ?? record.name ?? value),
      };
    }
    return { value: String(option), label: String(option) };
  });

const HeaderField = ({
  field,
  invalid,
}: {
  field: ProposeTemplateField;
  invalid: boolean;
}) => {
  const inputType = field.inputType?.toLowerCase();
  const disabled = Boolean(field.readOnly || field.calculated);
  const placeholder = invalid ? `${field.label}を入力してください` : undefined;

  return (
    <Form.Item
      name={field.id}
      label={field.label}
      valuePropName={inputType === "checkbox" || inputType === "boolean" ? "checked" : "value"}
      rules={field.required ? [{ required: true, message: `${field.label}を入力してください` }] : []}
    >
      {inputType === "checkbox" || inputType === "boolean" ? (
        <Checkbox disabled={disabled} />
      ) : inputType === "select" || inputType === "dropdown" ? (
        <Select
          allowClear
          disabled={disabled}
          options={fieldOptions(field.options)}
          placeholder={placeholder}
        />
      ) : inputType === "textarea" || inputType === "multiline" ? (
        <Input.TextArea
          autoSize={{ minRows: 2, maxRows: 5 }}
          disabled={disabled}
          placeholder={placeholder}
        />
      ) : (
        <Input
          type={inputType === "number" || inputType === "date" ? inputType : "text"}
          disabled={disabled}
          placeholder={placeholder}
        />
      )}
    </Form.Item>
  );
};

export const ProposeTemplateOrderFields = ({
  definition,
  invalidFieldIds,
}: {
  definition: ProposeTemplateFormDefinition;
  invalidFieldIds: ReadonlySet<string>;
}) => {
  if (!definition.headerFields?.length) return null;

  return (
    <Card size="small" title="書類情報">
      <Space direction="vertical" size="small" style={{ width: "100%" }}>
        {definition.headerFields.map((field) => (
          <HeaderField
            key={field.id}
            field={field}
            invalid={invalidFieldIds.has(field.id)}
          />
        ))}
      </Space>
    </Card>
  );
};
